module.exports = __webpack_public_path__ + "img/robot_p.48a64faa.png";